import * as React from 'react';
import Button, { ButtonProps as MuiButtonProps } from '@mui/material/Button';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import SlideLeftTransition from './transitions/SlideLeft';

interface ButtonProps {
    variant?: MuiButtonProps['variant'];
    children?: MuiButtonProps['children'];
}

interface Props extends DialogProps {
    showActions?: boolean;
    dialogTitle?: string | JSX.Element;
    contentDescription?: string | JSX.Element;
    form: JSX.Element;
    submitButtonProps?: ButtonProps;
    cancelButtonProps: ButtonProps;
    onSubmit?: () => void;
}
const FormDialog: FC<Props> = (props) => {
    const { showActions, dialogTitle, contentDescription, form, submitButtonProps, cancelButtonProps, onSubmit, onClose } = props;

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        onClose && onClose(event, 'backdropClick');
    };

    const contentId = `form-dialog-content`;

    return (
        <Dialog {...props} TransitionComponent={SlideLeftTransition}>
            {dialogTitle && <DialogTitle>{dialogTitle}</DialogTitle>}
            <DialogContent>
                {contentDescription && <DialogContentText id={contentId}>{contentDescription}</DialogContentText>}
                {form}
            </DialogContent>
            {showActions && (
                <DialogActions>
                    <Button {...cancelButtonProps} onClick={handleClose} />
                    <Button {...submitButtonProps} onClick={onSubmit} />
                </DialogActions>
            )}
        </Dialog>
    );
};

export default FormDialog;
